/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize EducationalMaterialView  View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './educationalMaterialLoad';

export const mapStateToPropsEducationalMaterialView = mapStateToProps;
export const mapDispatchToPropsEducationalMaterialView = mapDispatchToProps;

export default connect(
  mapStateToPropsEducationalMaterialView,
  mapDispatchToPropsEducationalMaterialView
)(View);
